// extracted by mini-css-extract-plugin
export default {"wrapper":"sB-z","addressLine":"tB-z","fullName":"uB-z"};